import { STATIC_ASSETS } from 'webclient.constants';
import { Box } from 'approot/shared/design-system/box/box.style';

const CsInSchoolsLogoPrint = () => (
  <Box $justifyContent="center" $marginTop={16}>
    <img
      src={`${STATIC_ASSETS}/code-for-schools.png`}
      alt="Code for Schools"
      width={122}
      height={47}
    />
  </Box>
);

export default CsInSchoolsLogoPrint;
